import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Galleria } from 'primereact/galleria';
import { classNames } from 'primereact/utils';
import logoImageWithTitle from '../assets/images/payPlus/payPlusWithTitle.png';

// Galleria için örnek görseller ve açıklamalar
const galleryItems = [
    {
        itemImageSrc: require('../assets/images/dashboard.png'),
        thumbnailImageSrc: require('../assets/images/dashboard.png'),
        title: "Kolay Senet Takibi",
        desc: "Tüm senetlerinizi tek ekranda yönetin.",
        alt: "Kolay Senet Takibi"
    },
    {
        itemImageSrc: require('../assets/images/dashboard.png'),
        thumbnailImageSrc: require('../assets/images/dashboard.png'),
        title: "Otomatik Hatırlatmalar",
        desc: "Müşterilerinize otomatik SMS ve e-posta gönderin.",
        alt: "Otomatik Hatırlatmalar"
    },
    {
        itemImageSrc: require('../assets/images/dashboard.png'),
        thumbnailImageSrc: require('../assets/images/dashboard.png'),
        title: "Detaylı Raporlama",
        desc: "Gelir ve tahsilat performansınızı analiz edin.",
        alt: "Detaylı Raporlama"
    },
    {
        itemImageSrc: require('../assets/images/dashboard.png'),
        thumbnailImageSrc: require('../assets/images/dashboard.png'),
        title: "Hızlı Senet Oluşturma",
        desc: "Müşteri ve kefil bilgileriyle anında senet oluşturun.",
        alt: "Hızlı Senet Oluşturma"
    },
    {
        itemImageSrc: require('../assets/images/dashboard.png'),
        thumbnailImageSrc: require('../assets/images/dashboard.png'),
        title: "7/24 Canlı Destek",
        desc: "Her an yanınızda olan uzman ekibimizle iletişime geçin.",
        alt: "7/24 Canlı Destek"
    }
];

const features = [
    { title: "Tek Tuşla Senet Oluşturma", desc: "Müşteri ve kefil bilgileri bir kere kaydederek hızlı ve profesyonel senet oluşturulmasını sağlar." },
    { title: "Örnek Ödeme Planı", desc: "Vade, faiz ve tutar bilgileri ile senet oluşturulmadan önce ödeme planı simüle edilir." },
    { title: "Detaylı SMS Bilgilendirme", desc: "Müşterilere otomatik ve kapsamlı SMS ve mail bildirimleri gönderilerek bilgilendirme trafiği en aza indirilir." },
    { title: "Müşteri Hatırlatma Servisi", desc: "Vadesine 7, 3 ve 1 gün kala ödeme hatırlatma SMS ve mailleri sistem tarafından otomatik olarak iletilir." },
    { title: "7/24 Canlı Destek", desc: "Kesintisiz destek hattı ile tüm sorulara anlık ve etkili çözümler sunulur." },
    { title: "Çoklu Ödeme Planları", desc: "Sabit, artan, azalan ve dinamik ödeme planı seçenekleriyle her müşteriye uygun esnek çözümler sunulur." },
    { title: "Profesyonel Dosya Çıktıları", desc: "Ödeme planları ve senet detayları Word ve Excel formatlarında arşivlenir." },
    { title: "Otomatik Gecikme Takibi", desc: "Ödeme gecikmeleri sistem tarafından otomatik tespit edilerek faiz hesaplamaları gerçekleştirilir." },
    { title: "Detaylı Analiz Raporları", desc: "Gelir, tahsilat ve gecikme performansı haftalık, aylık ve yıllık detaylı analizlerle raporlanır." },
    { title: "Hukuki Süreç Desteği", desc: "Gerekli durumlarda hukuki süreç desteği ile işletme güvence altına alınır." }
];

const responsiveOptions = [
    { breakpoint: '1024px', numVisible: 3 },
    { breakpoint: '768px', numVisible: 2 },
    { breakpoint: '560px', numVisible: 1 }
];

// Kayan yazı kartı (sadece mobilde)
const MarqueeCard = ({ text, desc }) => (
    <div className="relative bg-white rounded-2xl shadow-lg p-6 mb-8 overflow-visible">
        <div className="w-full flex overflow-x-hidden h-[3.5rem] items-center">
            <div className="animate-marquee text-blue-700 font-bold text-2xl whitespace-nowrap px-2">
                {text}
            </div>
            <div className="animate-marquee2 text-blue-700 font-bold text-2xl whitespace-nowrap px-2" aria-hidden="true">
                {text}
            </div>
        </div>
        <div className="mt-5 text-gray-700 text-base text-center">{desc}</div>
        <style>
            {`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
        @keyframes marquee2 {
          0% { transform: translateX(100%); }
          100% { transform: translateX(0); }
        }
        .animate-marquee {
          animation: marquee 15s linear infinite;
        }
        .animate-marquee2 {
          animation: marquee2 15s linear infinite;
        }
      `}
        </style>
    </div>
);

// Özellik kartı
const Feature = ({ title, desc }) => (
    <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-md h-full">
        <div className="text-blue-700 text-2xl">✔️</div>
        <div>
            <h4 className="text-lg font-semibold mb-1 text-slate-900">{title}</h4>
            <p className="text-gray-700">{desc}</p>
        </div>
    </div>
);

// Responsive ve ortalanan features grid
const FeaturesGrid = ({ features }) => {
    const getGridCols = () =>
        'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6';

    return (
        <div className={getGridCols()}>
            {features.map((f, i) => (
                <Feature key={i} title={f.title} desc={f.desc} />
            ))}
            {(() => {
                let cols = 1;
                if (typeof window !== 'undefined') {
                    if (window.innerWidth >= 1280) cols = 4;
                    else if (window.innerWidth >= 768) cols = 3;
                    else if (window.innerWidth >= 640) cols = 2;
                }
                const remainder = features.length % cols;
                if (remainder === 0) return null;
                return Array.from({ length: cols - remainder }).map((_, idx) => (
                    <div key={`empty-${idx}`} />
                ));
            })()}
        </div>
    );
};

const LandingPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [showThumbnails, setShowThumbnails] = useState(true);
    const [isAutoPlayActive, setAutoPlayActive] = useState(true);
    const [isFullScreen, setFullScreen] = useState(false);

    const galleria = useRef(null);

    useEffect(() => {
        const visitedCount = localStorage.getItem('visited_count');
        if (visitedCount) {
            window.location.href = '/login';
        } else {
            setIsLoading(false);
        }

        bindDocumentListeners();
        return () => unbindDocumentListeners();
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (galleria.current) {
            setAutoPlayActive(galleria.current.isAutoPlayActive());
        }
    }, [isAutoPlayActive]);

    const onItemChange = (event) => {
        setActiveIndex(event.index);
    };

    const toggleFullScreen = () => {
        // Mobilde fullscreen'i devre dışı bırak
        if (isMobile) return;

        if (isFullScreen) {
            closeFullScreen();
        } else {
            openFullScreen();
        }
    };

    const onFullScreenChange = () => {
        setFullScreen(prevState => !prevState);
    };

    const openFullScreen = () => {
        let elem = document.querySelector('.custom-galleria');
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    };

    const closeFullScreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    };

    const bindDocumentListeners = () => {
        document.addEventListener("fullscreenchange", onFullScreenChange);
        document.addEventListener("mozfullscreenchange", onFullScreenChange);
        document.addEventListener("webkitfullscreenchange", onFullScreenChange);
        document.addEventListener("msfullscreenchange", onFullScreenChange);
    };

    const unbindDocumentListeners = () => {
        document.removeEventListener("fullscreenchange", onFullScreenChange);
        document.removeEventListener("mozfullscreenchange", onFullScreenChange);
        document.removeEventListener("webkitfullscreenchange", onFullScreenChange);
        document.removeEventListener("msfullscreenchange", onFullScreenChange);
    };

    const handleGetStarted = () => {
        localStorage.setItem('visited_count', '1');
        window.location.href = '/login';
    };

    const handlePricing = () => {
        window.location.href = '/pricing';
    };

    const handleUserManual = () => {
        window.location.href = '/user-manual';
    };

    // Galleria template'leri
    const itemTemplate = (item) => {
        if (isFullScreen) {
            return <img src={item.itemImageSrc} alt={item.alt} />;
        }
        return (
            <img
                src={item.itemImageSrc}
                alt={item.alt}
                style={{ width: '100%', display: 'block', borderRadius: 16, background: '#f8fafc' }}
            />
        );
    };

    const thumbnailTemplate = (item) => (
        <div className="grid grid-nogutter justify-content-center">
            <img src={item.thumbnailImageSrc} alt={item.alt} style={{ display: 'block', borderRadius: 8, width: '60px', height: '40px', objectFit: 'cover' }} />
        </div>
    );

    // Footer'da title ve desc gösterimi
    const renderFooter = () => {
        let autoPlayClassName = classNames('pi', {
            'pi-play': !isAutoPlayActive,
            'pi-pause': isAutoPlayActive
        });

        let fullScreenClassName = classNames('pi', {
            'pi-window-maximize': !isFullScreen,
            'pi-window-minimize': isFullScreen
        });

        return (
            <div className="custom-galleria-footer">
                <Button
                    icon="pi pi-list"
                    onClick={() => setShowThumbnails(prevState => !prevState)}
                    className="p-button-rounded p-button-text"
                />
                <Button
                    icon={autoPlayClassName}
                    onClick={() => {
                        if (!isAutoPlayActive) {
                            galleria.current.startSlideShow();
                            setAutoPlayActive(true);
                        } else {
                            galleria.current.stopSlideShow();
                            setAutoPlayActive(false);
                        }
                    }}
                    className="p-button-rounded p-button-text"
                />
                {galleryItems && (
                    <div className="title-container">
                        <div className="text-center">
                            <h4 className="text-lg font-bold text-slate-700 mb-2">{galleryItems[activeIndex].title}</h4>
                            <p className="text-slate-600 text-sm">{galleryItems[activeIndex].desc}</p>
                        </div>
                    </div>
                )}
                {/* Mobilde fullscreen butonunu gizle */}
                {!isMobile && (
                    <Button
                        icon={fullScreenClassName}
                        onClick={() => toggleFullScreen()}
                        className="fullscreen-button p-button-rounded p-button-text"
                    />
                )}
                {/* Mobilde boş div ekle düzen için */}
                {isMobile && <div style={{ width: '40px' }}></div>}
            </div>
        );
    };

    const footer = renderFooter();
    const galleriaClassName = classNames('custom-galleria', {
        'fullscreen': isFullScreen
    });

    // Galleria style
    const galleriaStyle = isMobile
        ? { width: '100vw', maxWidth: '100vw' }
        : { width: '70vw', maxWidth: 900, margin: '0 auto' };

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-white via-slate-50 to-white">
            {/* Header */}
            <header className="bg-white shadow sticky top-0 z-50 border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center py-3">
                    <img
                        src={logoImageWithTitle}
                        alt="PayPlus Logo"
                        className="h-16 sm:h-20 md:h-24 object-contain transition-all"
                        style={{ maxWidth: 260 }}
                    />
                    <Button
                        label="Giriş"
                        className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-lg font-medium text-sm sm:text-base"
                        onClick={handleGetStarted}
                    />
                </div>
            </header>

            {/* Kayan yazı sadece mobilde */}
            {isMobile && (
                <section className="w-full px-2 mt-8 mb-4">
                    <MarqueeCard
                        text="Vadeli satış süreçleriniz sizi yormasın, Siz satışınıza odaklanın, takibini ekibimiz üstlensin."
                        desc="PayPlus vadeli satış yapan işletmeler için geliştirilmiş, profesyonel senet takip ve tahsilat yönetim sistemidir. Otomatik SMS bilgilendirme, detaylı raporlama ve kurumsal destek hizmeti ile tahsilat sürecinizi güvence altına almanıza yardımcı olur."
                    />
                </section>
            )}

            {/* Masaüstünde kayan yazı yok, diğer başlık ve açıklama sabit kalacak */}
            {!isMobile && (
                <section className="py-12 text-center w-full">
                    <h1 className="text-5xl font-extrabold text-slate-900 leading-tight max-w-5xl mx-auto">
                        Vadeli satış süreçleriniz sizi yormasın,{' '}
                        <span className="text-blue-700">
                            Siz satışınıza odaklanın, takibini ekibimiz üstlensin.
                        </span>
                    </h1>
                    <p className="text-xl text-gray-700 mt-6 max-w-4xl mx-auto">
                        PayPlus vadeli satış yapan işletmeler için geliştirilmiş, profesyonel senet takip ve tahsilat yönetim sistemidir. Otomatik SMS bilgilendirme, detaylı raporlama ve kurumsal destek hizmeti ile tahsilat sürecinizi güvence altına almanıza yardımcı olur.
                    </p>
                    <div className="mt-6 flex justify-center items-center space-x-4">
                        <div className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold shadow">+25 Aktif Kullanıcı</div>
                    </div>
                </section>
            )}

            {/* Galleria */}
            <section className="max-w-7xl mx-auto px-4 mt-16 mb-8">
                <h2 className="text-3xl font-bold mb-10 text-slate-900 text-center">Size ne sunuyoruz?</h2>
                <div className="flex flex-col items-center justify-center mb-12">
                    <Button label="Kılavuza gitmek için tıklayınız !" className="bg-blue-700 text-white font-bold px-8 py-3 rounded-lg" onClick={handleUserManual} />
                    <div style={galleriaStyle}>
                        <Galleria
                            ref={galleria}
                            value={galleryItems}
                            activeIndex={activeIndex}
                            onItemChange={onItemChange}
                            showThumbnails={showThumbnails}
                            showItemNavigators
                            showItemNavigatorsOnHover={false}
                            numVisible={5}
                            circular
                            autoPlay
                            transitionInterval={4000}
                            responsiveOptions={responsiveOptions}
                            item={itemTemplate}
                            thumbnail={thumbnailTemplate}
                            footer={footer}
                            style={{ width: '100%' }}
                            className={galleriaClassName}
                        />
                    </div>
                </div>
                <FeaturesGrid features={features} />
            </section>

            {/* Fiyat Kartı */}
            <section className="max-w-4xl mx-auto text-center mb-24">
                <div className="bg-gradient-to-r from-blue-700 to-blue-800 text-white p-10 rounded-2xl shadow-lg">
                    <div className="text-sm mb-2">Özel Tanıtım Fırsatı</div>
                    <div className="text-4xl font-bold mb-3">2.500₺ / Ay</div>
                    <div className="text-base">İlk 14 gün tamamen ücretsiz deneyim fırsatı</div>
                    <div className="mt-6">
                        <Button label="Güncel Fiyat Listesi İçin Tıklayın" className="bg-white text-blue-700 font-bold px-8 py-3 rounded-lg" onClick={handlePricing} />
                    </div>
                </div>
            </section>

            {/* Destek Ekibi */}
            <section className="bg-slate-50 py-24 text-center">
                <h3 className="text-3xl font-bold mb-6 text-slate-900">Profesyonel Destek Ekibi Yanınızda</h3>
                <p className="text-lg text-gray-700 mb-10 max-w-2xl mx-auto">
                    Teknik destek, sistem kullanımı ve tüm sorularınız için uzman destek ekibimize 7/24 ulaşabilirsiniz.
                </p>
                <Button label="Bize Ulaşın" className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-4 rounded-xl font-semibold" />
            </section>

            {/* CTA */}
            <section className="bg-gradient-to-r from-blue-700 to-slate-700 py-20 text-center text-white">
                <h2 className="text-4xl font-bold mb-4">PayPlus ile Tahsilatınızı Güvence Altına Alın</h2>
                <p className="text-xl mb-8">14 gün ücretsiz deneyin. Kredi kartı bilgisi gerekmez.</p>
                <Button label="Ücretsiz Deneme Başlat" className="bg-white text-blue-700 px-10 py-4 text-xl font-bold rounded-xl shadow-lg" onClick={handleGetStarted} />
            </section>

            {/* Footer */}
            <footer className="bg-gray-900 text-gray-400 py-12 text-sm">
                <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-10">
                    <div>
                        <h4 className="text-white font-semibold mb-3">PayPlus</h4>
                        <p>Vadeli satış yapan işletmeler için profesyonel senet takip ve tahsilat yönetim platformu.</p>
                    </div>
                    <div>
                        <h4 className="text-white font-semibold mb-3">İletişim</h4>
                        <p>Telefon: 0532 599 9867</p>
                        <p>E-posta: info@payplus.com.tr</p>
                    </div>
                    <div>
                        <h4 className="text-white font-semibold mb-3">Hızlı Erişim</h4>
                        <Button label="Giriş" className="bg-blue-700 text-white w-full mb-2" onClick={handleGetStarted} />
                        <Button label="Bize Ulaşın" className="bg-blue-600 text-white w-full" />
                    </div>
                </div>
                <div className="text-center mt-8 border-t border-gray-700 pt-4">© 2025 PayPlus. Tüm hakları saklıdır.</div>
            </footer>

            {/* Custom CSS */}
            <style>
                {`
                .custom-galleria-footer {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: rgba(255, 255, 255, 0.95);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    color: #334155;
                    padding: 16px;
                    border-bottom-left-radius: 16px;
                    border-bottom-right-radius: 16px;
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
                }

                .custom-galleria-footer .title-container {
                    flex: 1;
                    text-align: center;
                    margin: 0 16px;
                }

                .custom-galleria.fullscreen {
                    border-radius: 0;
                }

                .custom-galleria .p-galleria-thumbnail-item-content {
                    width: 60px !important;
                    height: 40px !important;
                }

                .custom-galleria .p-galleria-thumbnail-item-content img {
                    width: 60px !important;
                    height: 40px !important;
                    object-fit: cover !important;
                }

                .custom-galleria-footer .p-button {
                    color: #475569 !important;
                    background: rgba(255, 255, 255, 0.8) !important;
                    border: 1px solid rgba(71, 85, 105, 0.2) !important;
                }

                .custom-galleria-footer .p-button:hover {
                    background: rgba(255, 255, 255, 1) !important;
                    color: #334155 !important;
                }
                `}
            </style>
        </div>
    );
};

export default LandingPage;